import React, { Component } from 'react';
import { connect } from 'react-redux';

import ArticleItem from './article/article-item';
import BookItem from './book/book-item';
import EventItem from './event/event-item';
import ProtocolItem from './protocol/protocol-item';
import OpinionItem from './opinion/opinion-item';

class PostView extends Component {
	renderPosts( posts ) {
		if ( Array.isArray( posts ) && posts.length ) {
			return posts.map( post => {
				switch ( post.post_type ) {
					case 'book':
						return <BookItem book={ post } key={ post.id } />;
						break;
					case 'event':
						return <EventItem event={ post } key={ post.id } />;
						break;
					case 'protocol':
						return <ProtocolItem protocol={ post } key={ post.id } />;
						break;
					case 'opinion':
						return <OpinionItem opinion={ post } key={ post.id } />;
						break;
					case 'posts':
					default:
						return <ArticleItem post={ post } key={ post.id } />;
						break;
				}
			} );
		} else {
			return [ 0, 1, 2, 3 ].map( i => this.getEmptyRow( i ) );
		}
	}

	getEmptyRow( i ) {
		return (<article className="two-col-content-panel">
				<div className="col-sm-8">
					<div role="tabpanel" className="tab-pane fade in active">
						<h3 className="entry-title">&nbsp;</h3>
					</div>
				</div>
				<div className="col-sm-4 attached-documents">
				</div>
			</article>
		);
	}

	render() {
		return (<div className={ `${this.props.postType}-list` }>
				{ this.renderPosts( this.props.posts ) }
			</div>
		);
	}
}

function mapStateToProps( { posts, postType } ) {
	return { posts, postType };
}

export default connect( mapStateToProps )( PostView );